import styled from 'styled-components';
import { colors } from '../../style/colors';
import { SubH } from '../../style/typography';
import { min } from '../../lib/responsive';

const RotatingBannerContainer = styled.div`
  background-color: ${colors.PERIWINKLE};
  margin-top: 38rem;
  @media ${min.tablet} {
    margin-top: 44rem;
  }
`;

const RotatingText = styled(SubH)`
  text-transform: uppercase;
  padding-left: 3rem;
`;

export { RotatingBannerContainer, RotatingText };
